import { extend } from 'vee-validate'
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  max as rule_max,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
  is as rule_is,
  image as rule_image,
  max_value as rule_max_value,
  min_value as rule_min_value,
  is_not as rule_is_not,
  size as rule_size,
  dimensions as rule_dimensions,
  numeric as rule_numeric,
  // date_format as rule_date_format
} from 'vee-validate/dist/rules'

// eslint-disable-next-line object-curly-newline
import {
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorCreditCard,
  termsValidator,
  arrayValidator,
  validateDate,
} from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const max = extend('max', rule_max)

export const numeric = extend('numeric', rule_numeric)

export const is = extend('is', rule_is);

export const image = extend('image', rule_image);

export const max_value = extend('max_value', {
  validate: rule_max_value.validate,
  message: 'The {_field_} cannot be greater than Maximum Amount',
})

export const min_value = extend('min_value', rule_min_value)

export const is_not = extend('is_not', rule_is_not)

export const size = extend('size', rule_size);

export const dimensions = extend('dimensions', rule_dimensions)

export const validate_date = extend('validate_date', {
  validate: validateDate,
  message: 'Please enter valid date',
})

export const positive = extend('positive', {
  validate: validatorPositive,
  message: 'Please enter positive number!',
})

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!',
})

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Your {_field_} must contain at least eight(8) characters, one uppercase, one lowercase, one special character and one digit',
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
})

export const terms = extend('terms-and-conditions', {
  validate: termsValidator,
  message: 'You must agree to the terms and conditions before proceeding',
});

export const is_array = extend('is_array', {
  validate: arrayValidator,
  message: 'The {_field_} is required and must have an option selected',
})
